var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('forum-search'),_vm._l((_vm.threads),function(thread){return _c('forum-thread-box',{key:thread._id,staticClass:"inf",attrs:{"id":("id-" + (thread._id)),"thread":thread,"category":_vm.category}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }